import styled from 'styled-components'

export const SectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 0.75rem;
`

export const SectionLabel = styled.span`
  font-size: 0.82rem;
  font-weight: 600;
  color: #374151;
`

export const DropZone = styled.div<{ isDragActive: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  border: 2px dashed ${({ isDragActive }) => (isDragActive ? '#0090D3' : '#d1d5db')};
  border-radius: 0.6rem;
  padding: 0.65rem 1rem;
  background: ${({ isDragActive }) => (isDragActive ? '#E6F4FB' : '#fafafa')};
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: #0090D3;
    background: #E6F4FB;
  }
`

export const DropZoneText = styled.span`
  font-size: 0.8rem;
  color: #6b7280;
`

export const HiddenInput = styled.input`
  display: none;
`

export const AttachmentList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
`

export const AttachmentItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.6rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  padding: 0.5rem 0.65rem;
  background: #fff;
  transition: box-shadow 0.15s ease;

  &:hover {
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  }
`

export const AttachmentIcon = styled.div`
  display: flex;
  align-items: center;
  color: #6b7280;
  flex-shrink: 0;
`

export const AttachmentMeta = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  flex: 1;
  min-width: 0;
`

export const AttachmentSize = styled.span`
  font-size: 0.72rem;
  color: #9ca3af;
`

export const TitleDisplay = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.4rem;
  font-size: 0.8rem;
  color: #374151;
  font-weight: 500;
  border: 1px solid transparent;
  border-radius: 0.3rem;
  padding: 0.25rem 0.35rem;
  cursor: text;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: border-color 0.15s ease;

  svg {
    display: none;
    flex-shrink: 0;
    color: #6b7280;
  }

  &:hover {
    border-color: #d1d5db;
    svg {
      display: block;
    }
  }
`

export const TitleInput = styled.input`
  font-size: 0.8rem;
  color: #374151;
  font-weight: 500;
  border: 1px solid #0090D3;
  border-radius: 0.3rem;
  padding: 0.25rem 0.35rem;
  outline: none;
  width: 100%;
  font-family: inherit;
`

export const RemoveButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  color: #9ca3af;
  padding: 0.2rem;
  border-radius: 50%;
  flex-shrink: 0;
  transition: color 0.15s ease, background 0.15s ease;

  &:hover {
    color: #ef4444;
    background: #fef2f2;
  }
`

export const DownloadButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  color: #9ca3af;
  padding: 0.2rem;
  border-radius: 50%;
  flex-shrink: 0;
  transition: color 0.15s ease, background 0.15s ease;

  &:hover {
    color: #0090D3;
    background: #E6F4FB;
  }
`
